<cs-modal [settings]="settingsModal"></cs-modal>
<div class="login bg-aircontainer">
    <div class="container h-100 scroll-y">
        <div class="login__container row justify-content-center align-items-center py-3">
            <div class="col-12 col-lg-9">
                <div class="login__content d-flex flex-column flex-md-row">
                    <div class="login__brand d-flex flex-row flex-md-column justify-content-between flex-wrap p-3">
                        <div class="login__brand__title text-center mt-md-3">
                            <app-auth-logo></app-auth-logo>
                        </div>
                    </div>
                    <form class="login__form p-3 flex-grow-1 bg-white" [formGroup]="form" (ngSubmit)="login()"
                        novalidate>
                        <div class="login__form__title mb-4">
                            <div class="d-flex align-items-end">
                                <h2>Sign in to</h2>
                                <img src="assets/img/logo-sprintpass.svg" alt="SprintPass">
                            </div>
                            <small>Enter your details below.</small>
                        </div>
                        <div class="form-group">
                            <label for="user-email">Email address</label>
                            <input id="user-email" #inputEmail class="form-control" type="email"
                                placeholder="Enter your email" formControlName="usr_email">
                        </div>
                        <div class="form-group">
                            <label for="user-password">Password</label>
                            <input id="user-password" class="form-control" type="password"
                                placeholder="Enter your password" formControlName="usr_password"
                                (change)="!form.value.usr_email && fixEmailAutoFill(inputEmail.value)">
                        </div>
                        @if (initialized) {
                        <div class="login-exception text-danger bg-gray-lightest p-3" [class.invisible]="!exception">
                            <span class="material-icons m-0 me-2 align-middle" [attr.aria-hidden]="!exception">
                                warning
                            </span>
                            <span class="align-middle">{{exception?.message}}</span>
                        </div>
                        }
                        <a [routerLink]="['/recover-password']" class="btn-link font-size--small">Did you forget your
                            password?</a>
                        <div class="form-group d-flex align-items-center mt-3">
                            <button type="submit" class="btn btn-primary  mb-0"
                                [disabled]="!(form.valid || form.pristine) || sending" [class.loading]="sending">
                                Sign In
                            </button>
                            <div class="d-flex flex-grow-1 flex-wrap ms-3">
                                <div>
                                    <span class="m-0 text-medium-emphasis font-size--small">Don't have an
                                        account?</span>&nbsp;<a [routerLink]="['/sign-up']" class="btn-link">Sign Up</a>
                                </div>
                                <span class="mx-2 text-medium-emphasis">|</span>
                                @if (initialized) {
                                <div>
                                    <span class="m-0 text-medium-emphasis font-size--small">Find your
                                        AWBs</span>&nbsp;<a [routerLink]="['/search-my-pickup']" class="btn-link"
                                        appPopperLink [targetPopper]="tooltip" placement="right-end" [offset]="[10,15]"
                                        [eventsEnabled]="true" strategy="fixed" trigger="hover focus">Here</a>
                                    <div class="cs-popper text-center" #tooltip>
                                        <span class="material-icons text-info font-size--xx-large mb-2">
                                            info
                                        </span>
                                        <p class="mb-0 text-medium-emphasis text-start">Click on the link<br>if you
                                            want
                                            to know<br>which AWBs are<br>included in your PKU#</p>
                                        <div class="cs-popper__arrow" data-popper-arrow></div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>